import { ArrowUp } from '@phosphor-icons/react';
import { useLang } from '@/context/LanguageContext';
import { UI_TEXT } from '@/data/tradeData';

export default function Footer({ minimal }) {
  const { lang } = useLang();
  const t = UI_TEXT[lang].footer;
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-[#0A0A0A] pb-16 lg:pb-0">
      {!minimal && (
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 sm:py-24">
          <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
            <div>
              <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-6xl tracking-tighter text-white leading-none">
                {t.cta}<br /><span className="text-[#E31937]">{t.ctaSub}</span>
              </h2>
            </div>
            <a href="tel:3059048567" data-testid="footer-cta-phone" className="bg-[#E31937] text-white font-bold uppercase tracking-wider px-8 py-4 hover:bg-white hover:text-[#0A0A0A] transition-colors text-sm shrink-0">{t.phone}</a>
          </div>
        </div>
      )}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-xs text-[#666]">&copy; {new Date().getFullYear()} Contractors of South Florida LLC. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <a href={lang === 'es' ? '/es/privacidad' : '/privacy'} className="text-xs text-[#666] hover:text-white transition-colors">Privacy</a>
            <a href={lang === 'es' ? '/es/terminos' : '/terms'} className="text-xs text-[#666] hover:text-white transition-colors">Terms</a>
            <a href={lang === 'es' ? '/es/terminos-sms' : '/sms-terms'} className="text-xs text-[#666] hover:text-white transition-colors">SMS Terms</a>
            <button onClick={scrollToTop} data-testid="scroll-to-top" className="w-8 h-8 bg-white/5 border border-white/10 flex items-center justify-center hover:border-[#E31937] transition-colors" aria-label="Top">
              <ArrowUp size={14} className="text-white" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
